import { requestSiteMonitoring } from 'api/monitoring'

export {
  navigateDetails,
  navigateEditOnlySite,
  createNavigateRfpStyleViewSite,
  createNavigateViewSiteWithAllHistories,
  createNavigateIndividualConfirmedView,
  createNavigateIndividualDefaultViewSite,
  createNavigateReviewDetails,
  createNavigateIndividualReviewedByRfp,
} from '../../utils/navigationHandlers'

export function handleCreateMonitoring (siteId, profileID, history) {
  requestSiteMonitoring(siteId, profileID).then((data) => {
    history(`/site/${siteId}/monitoring/${data.id}/about`)
  })
}

export function handleGetMonitoring (siteId, monitoringId, history) {
  history(`/site/${siteId}/monitoring/${monitoringId}/about`)
}
